<div
  [formGroup]="formGroup!"
  [class]="config?.cssClass ? config!.cssClass: ''"
>
  <button
    class="btn btn-colour-blue-600 {{ config?.cssClass || '' }}"
    type="submit"
    [disabled]="config?.disabled"
    (click)="config?.onSubmit?.(formGroup!)"
  >
    {{ config?.label }}
  </button>
</div>
